// AUTH Helpers
export const AUTH_LOCAL_TOKEN_UPDATED = 'AUTH_LOCAL_TOKEN_UPDATED';
export const SET_USER = 'SET_USER';

export const SET_UTMS = 'SET_UTMS';

// Student Profile
export const STUDENT_GET_PROFILE_REQUEST = 'STUDENT_GET_PROFILE_REQUEST';
export const STUDENT_GET_PROFILE_SUCCESS = 'STUDENT_GET_PROFILE_SUCCESS';
export const STUDENT_GET_PROFILE_FAILURE = 'STUDENT_GET_PROFILE_FAILURE';
export const STUDENT_UPDATE_PROFILE_REQUEST = 'STUDENT_UPDATE_PROFILE_REQUEST';
export const STUDENT_UPDATE_PROFILE_SUCCESS = 'STUDENT_UPDATE_PROFILE_SUCCESS';
export const STUDENT_UPDATE_PROFILE_FAILURE = 'STUDENT_UPDATE_PROFILE_FAILURE';

// Bookings
export const STUDENT_GET_BOOKINGS_REQUEST = 'STUDENT_GET_BOOKINGS_REQUEST';
export const STUDENT_GET_BOOKINGS_SUCCESS = 'STUDENT_GET_BOOKINGS_SUCCESS';
export const STUDENT_GET_BOOKINGS_FAILURE = 'STUDENT_GET_BOOKINGS_FAILURE';
// Orders
export const STUDENT_GET_ORDERS_REQUEST = 'STUDENT_GET_ORDERS_REQUEST';
export const STUDENT_GET_ORDERS_SUCCESS = 'STUDENT_GET_ORDERS_SUCCESS';
export const STUDENT_GET_ORDERS_FAILURE = 'STUDENT_GET_ORDERS_FAILURE';

// Subscriptions
export const STUDENT_GET_SUBSCRIPTIONS_REQUEST = 'STUDENT_GET_SUBSCRIPTIONS_REQUEST';
export const STUDENT_GET_SUBSCRIPTIONS_SUCCESS = 'STUDENT_GET_SUBSCRIPTIONS_SUCCESS';
export const STUDENT_GET_SUBSCRIPTIONS_FAILURE = 'STUDENT_GET_SUBSCRIPTIONS_FAILURE';

// Search
export const FACETS_REQUEST = 'FACETS_REQUEST';
export const FACETS_SUCCESS = 'FACETS_SUCCESS';
export const FACETS_FAILURE = 'FACETS_FAILURE';
export const FILTER_UPDATED = 'FILTER_UPDATED';
export const SEARCH_TERM_UPDATED = 'SEARCH_TERM_UPDATED';
export const FILTERS_SET_FROM_URL = 'FILTERS_SET_FROM_URL';
export const QUERY_SET_FROM_URL = 'QUERY_SET_FROM_URL';
export const SEARCH_MODE_ENABLED = 'SEARCH_MODE_ENABLED';
export const SEARCH_MODE_DISABLED = 'SEARCH_MODE_DISABLED';
export const MAP_SHOWN = 'MAP_SHOWN';
export const MAP_HIDDEN = 'MAP_HIDDEN';
export const SEARCH_CLEARED = 'SEARCH_CLEARED';
export const PAGE_CHANGED = 'PAGE_CHANGED';
export const SET_SEARCH_DATA = 'SET_SEARCH_DATA';
export const SET_LIST_CACHE = 'SET_LIST_CACHE';
export const SET_SELECTED_LIST = 'SET_SELECTED_LIST';
export const SET_TOTAL_HITS = 'SET_TOTAL_HITS';

// Educator
export const EDUCATOR_PAGE_GET_REQUEST = 'EDUCATOR_PAGE_GET_REQUEST';
export const EDUCATOR_PAGE_GET_SUCCESS = 'EDUCATOR_PAGE_GET_SUCCESS';
export const EDUCATOR_PAGE_GET_FAILURE = 'EDUCATOR_PAGE_GET_FAILURE';
export const EDUCATOR_CACHED_EDUCATOR_DATA_USED = 'EDUCATOR_CACHED_EDUCATOR_DATA_USED';

// Course
export const COURSE_PAGE_GET_REQUEST = 'COURSE_PAGE_GET_REQUEST';
export const COURSE_PAGE_GET_SUCCESS = 'COURSE_PAGE_GET_SUCCESS';
export const COURSE_PAGE_GET_FAILURE = 'COURSE_PAGE_GET_FAILURE';
export const OCCURRENCES_GET_REQUEST = 'OCCURRENCES_GET_REQUEST';
export const OCCURRENCES_GET_SUCCESS = 'OCCURRENCES_GET_SUCCESS';
export const OCCURRENCES_GET_FAILURE = 'OCCURRENCES_GET_FAILURE';
export const COURSE_CURRENT_OCCURRENCE_SET = 'COURSE_CURRENT_OCCURRENCE_SET';
export const COURSE_SELECTED_DATE_SET = 'COURSE_SELECTED_DATE_SET';

export const FAQS_LOADING = 'FAQS_LOADING';
export const FAQS_LOADING_FAILED = 'FAQS_LOADING_FAILED';
export const FAQS_LOADED_FOR_COURSE = 'FAQS_LOADED_FOR_COURSE';
